export type Risk = 'Muy alto' | 'Alto' | 'Medio' | 'Bajo' | 'Muy bajo' | 'Nulo o despreciable';

export const RISK_ORDER: Risk[] = ['Muy alto', 'Alto', 'Medio', 'Bajo', 'Muy bajo', 'Nulo o despreciable'];

export const RISK_COLOR: Record<Risk, string> = {
  'Muy alto': 'var(--colorResultVeryHigh)',
  'Alto': 'var(--colorResultHigh)',
  'Medio': 'var(--colorResultMedium)',
  'Bajo': 'var(--colorResultLow)',
  'Muy bajo': 'var(--colorResultNull)',
  'Nulo o despreciable': 'var(--colorResultNull)',
};
